module.exports = __webpack_public_path__ + "static/media/ic_clockPointage.14f09e45.svg";